import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
import { ButtonStylingModel } from '../button/button-styling.model';
import { MenuStylingModel } from '../menu/menu-styling.model';
export class ButtonMenuStylingModel extends CoreStylingModel {

  buttonStyling: ButtonStylingModel;

  menuStyling: MenuStylingModel;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);

    if (this.buttonStyling == null) { this.buttonStyling = new ButtonStylingModel(); }
    if (this.menuStyling == null) { this.menuStyling = new MenuStylingModel(); }
  }
}

function ButtonMenuStylingModel_tsickle_Closure_declarations() {
/** @type {?} */
ButtonMenuStylingModel.prototype.buttonStyling;
/** @type {?} */
ButtonMenuStylingModel.prototype.menuStyling;
}

